// In-memory store for Invitation - Internal (Panitia Lelang).
//
// TODO(API): stands in for the backend until the internal-invitation contract
// exists. Mirrors invitationExternalStore / procurementStore so the swap is
// mechanical; callers go through invitationInternalApi.js, not this directly.
//
// Only one mutation exists (Confirm) — the committee screens are otherwise
// read-only.

import { SEED_INVITATIONS } from './invitationInternalDummyData';
import {
  INVITATION_STATUS,
  PARTICIPATION,
  SEARCHABLE_FIELDS,
  SORTABLE_FIELDS,
  isValidEmail,
} from './invitationInternalConstants';

const clone = obj => JSON.parse(JSON.stringify(obj));

let records = clone(SEED_INVITATIONS);

// Keyword search — Title, Id Procurement and Description only (DOD item 2).
const matchesSearch = (r, q) => {
  if (!q) return true;
  const needle = q.toLowerCase();
  return SEARCHABLE_FIELDS.some(f =>
    String(r[f] || '')
      .toLowerCase()
      .includes(needle)
  );
};

const getSortValue = (r, field) =>
  SORTABLE_FIELDS.includes(field) ? r[field] || '' : '';

export const list = ({
  search = '',
  page = 1,
  pageSize = 10,
  sortField = null,
  sortDir = 'asc',
} = {}) => {
  let filtered = records.filter(r => matchesSearch(r, search));

  if (sortField) {
    filtered = [...filtered].sort((a, b) => {
      const cmp = String(getSortValue(a, sortField)).localeCompare(
        String(getSortValue(b, sortField)),
        undefined,
        { numeric: true, sensitivity: 'base' }
      );
      return sortDir === 'asc' ? cmp : -cmp;
    });
  }

  const totalCount = filtered.length;
  const start = (page - 1) * pageSize;
  return { items: clone(filtered.slice(start, start + pageSize)), totalCount };
};

// Single record for the Detail page. Returns null on unknown id so the caller
// can render its not-found panel.
export const getById = id => {
  const found = records.find(r => r.id === id);
  return found ? clone(found) : null;
};

// Confirm attendance. `mode` is Present or Delegate; a Delegate must carry a
// name and a valid email (validated here too, so the rule holds even if a
// caller skips the UI check). Only an Open invitation can be confirmed.
export const confirm = (id, { mode, name, email } = {}) => {
  const record = records.find(r => r.id === id);
  if (!record) throw new Error('Invitation not found');
  if (record.invitationStatus !== INVITATION_STATUS.OPEN) {
    throw new Error('This invitation has already been confirmed');
  }
  if (mode !== PARTICIPATION.PRESENT && mode !== PARTICIPATION.DELEGATE) {
    throw new Error('Please choose Present or Delegate');
  }
  if (mode === PARTICIPATION.DELEGATE) {
    if (!String(name || '').trim())
      throw new Error('Delegate name is required');
    if (!isValidEmail(email))
      throw new Error('A valid delegate email is required');
  }

  record.invitationStatus = INVITATION_STATUS.CONFIRMED;
  record.participant =
    mode === PARTICIPATION.DELEGATE
      ? { mode, name: name.trim(), email: email.trim() }
      : { mode, name: null, email: null };
  record.confirmedAt = new Date().toISOString();
  return clone(record);
};

// Test/util hook — reset back to the seed set.
export const _reset = () => {
  records = clone(SEED_INVITATIONS);
};
